import type { FunctionComponent } from "react";

import { SocialMedia } from "scmp-app/components/footer/social-media/enums";

import { FacebookUrl, InstagramUrl } from "./consts";
import FacebookIcon from "./icon-facebook.svg";
import InstagramIcon from "./icon-instagram.svg";
import { Container, IconContainer } from "./styles";

type Props = {
  className?: string;
};

export const StyleSocialMedia: FunctionComponent<Props> = ({ className }) => {
  const socialMediaMap = {
    [SocialMedia.Facebook]: {
      icon: FacebookIcon,
      url: FacebookUrl,
    },
    [SocialMedia.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl,
    },
  };

  const renderIcon = (media: keyof typeof socialMediaMap) => {
    const { icon: Component, url } = socialMediaMap[media];
    return (
      <IconContainer key={media}>
        <a href={url} rel="noopener noreferrer" target="_blank">
          <Component />
        </a>
      </IconContainer>
    );
  };

  return (
    <Container className={className}>
      {([SocialMedia.Facebook, SocialMedia.Instagram] as const).map(media => renderIcon(media))}
    </Container>
  );
};

StyleSocialMedia.displayName = "StyleSocialMedia";
